<p-panel [styleClass]="'zoesen-tooltip-header'" [style]="{width: 'auto'}" *ngIf="header">
  <ng-template pTemplate="header">
    <span class="p-mr-2 fas fa-umbrella-beach text-yellow"></span> Happy {{title}}! 
  </ng-template>
</p-panel>

<p-panel [styleClass]="'zoesen-tooltip'" [style]="{width: '300px'}" *ngIf="!header">
  <ng-template pTemplate="header">
    {{title}}
  </ng-template>
  <div class="p-pt-1" [innerHTML]="content|safeHtml"></div>
  <ng-template pTemplate="footer">
    {{footer}}
  </ng-template>
</p-panel>